import base64heller from 'base64-heller';
import base64js from 'base64-js';

export default {
	decode: base64heller.decode.bind(base64heller),
	encode: base64heller.encode.bind(base64heller),
	fromByteArray: base64js.fromByteArray,
	toByteArray: base64js.toByteArray
};
